/*
 *   Copyright (c) 2025 LoginID Inc
 *   All rights reserved.

 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at

 *   http://www.apache.org/licenses/LICENSE-2.0

 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import { CheckoutExternalPage } from "./pages/checkout/external";
import { createTheme, MantineProvider } from "@mantine/core";
import { Route, Routes } from "react-router-dom";
import { CheckoutPage } from "./pages/checkout";
import DiscoverPage from "./pages/discover";
import BankingPage from "./pages/banking";
import "@mantine/core/styles.css";
import "./App.css";
import { LoginPrompt } from "./pages/wallet";

const brand = process.env.REACT_APP_BRAND || "AWallet";
const theme = createTheme({
  /** Put your mantine theme override here */

  primaryColor: `${brand}`,
  colors: {
    'Paze': ["#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8", "#0F42F8"],
    'AWallet': ["#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688", "#009688"],
    'Konek': ["#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA", "#CA27CA"],
    'Interac': [
      "#fff8df",
      "#ffefca",
      "#ffde99",
      "#ffcc63",
      "#ffb92a",
      "#ffb318",
      "#ffae03",
      "#e49800",
      "#cb8700",
      "#b07300"],
    'Cookies': [
      "#f3edff",
      "#e0d7fa",
      "#beabf0",
      "#9a7de6",
      "#7c55de",
      "#693cd9",
      "#5f30d8",
      "#4f23c0",
      "#461eac",
      "#3b1898"
    ],
  }
});

function App() {
  return (
    <div className="App">
      <MantineProvider theme={theme}>
        <Routes>
          <Route path="/" element={<CheckoutPage />} />
          <Route path="/login" element={<LoginPrompt />} />
          <Route path="/idv" element={<DiscoverPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/banking" element={<BankingPage />} />
          <Route path="/external" element={<CheckoutExternalPage />} />
        </Routes>
      </MantineProvider>
    </div>
  );
}

export default App;
